import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { GoogleMapsLoaderService } from '../../../../../core/services/google-maps-loader.service';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { CLIENT_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/client';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { FORM_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/form';
import { TASK_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/task';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/timesheet';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { ClientStoreService } from '../../../../../state/modules/client/client-store.service';
import { FormStoreService } from '../../../../../state/modules/form/form-store.service';
import { TaskStoreService } from '../../../../../state/modules/task/task-store.service';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { FormActionComponent } from '../../../forms/components/form-action/form-action.component';
import { TaskGroupListActionComponent } from '../task-group-list-action/task-group-list-action.component';
import { ScanTaskGroupFormConstant } from './scan-task-group-forms.constant';
import { ToasterService } from '../../../../../core/services/toaster.service';

@Component({
  standalone: false,
  selector: 'kt-scan-task-group-forms',
  templateUrl: './scan-task-group-forms.component.html',
  styleUrls: ['./scan-task-group-forms.component.scss'],
})
export class ScanTaskGroupFormsComponent extends ModalBaseClass implements OnInit, AfterViewInit {

  shiftInfo = null;
  areaId = null;
  area = null;
  forms = [];
  tasks = [];
  buttonConfig = BUTTON_CONFIG;
  activeForm = null;
  timesheetForms = [];
  timeSheetTasks = [];
  timesheetTasksForEditMode = [];
  activeTasks = null;
  formConstant = ScanTaskGroupFormConstant;
  location = { latitude: CommonUtil.Latitude, longitude: CommonUtil.Longitude };
  locationAvailable = false;
  locationLoading = true;
  commentFormGroup = new UntypedFormGroup({});
  distanceFromActualLocation = 0;
  isLastStepReached = false;
  isLoopScan = false;
  loading = signal(false);
  loopInfo = null;
  user_id = 0;
  mapReady = signal(false);
  infoContent = '';
  isPatrolScan = false;
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  private readonly mapsLoader = inject(GoogleMapsLoaderService);

  @ViewChild('wizard', { static: true }) el: ElementRef;


  constructor(private clientStoreService: ClientStoreService,
    private formStoreService: FormStoreService,
    private taskStoreService: TaskStoreService,
    public activeModal: NgbActiveModal,
    private timesheetStoreService: TimesheetStoreService,
    private toaster: ToasterService,
    private ngbModal: NgbModal,
    private cdr: ChangeDetectorRef) {
    super(ngbModal);

    this.mapsLoader.load().then(() => this.mapReady.set(true));
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.locationAvailable = true;
        this.locationLoading = false;
        this.location.latitude = position.coords.latitude;
        this.location.longitude = position.coords.longitude;
        this.distanceFromActualLocation = CommonUtil.distance(this.location.latitude, this.location.longitude, (+this.shiftInfo.area.area_latitude), (+this.shiftInfo.area.area_longitude), 'K');
        this.cdr.detectChanges();
      }, (error) => {
        this.onLocationUnavailable(error && error.message);
      }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 });
    } else {
      this.onLocationUnavailable('Geolocation is not supported by this browser.');
    }
  }

  private onLocationUnavailable(reason: string) {
    this.locationAvailable = false;
    this.locationLoading = false;
    this.toaster.errorShow(
      'Your location could not be detected, so the distance from the checkpoint cannot be verified. Enable location access and reopen this scan.',
      'Location Unavailable',
      { closeButton: true, timeOut: 5000 });
    console.warn('[scan-task-group-forms] geolocation unavailable:', reason);
    this.cdr.detectChanges();
  }

  openInfoWindow(marker: MapMarker, content: string) {
    this.infoContent = content;
    if (this.infoWindow) {
      this.infoWindow.open(marker);
    }
  }

  ngOnInit() {
    this.dispatchGetTaskGroupForm();
  }

  setWizardConfig() {
    setTimeout(() => {
      const wizard = new KTWizard(this.el.nativeElement, {
        startStep: 1,
      });
      wizard.on('beforeNext', (wizardObj) => {
        const mandatoryFormExist = this.forms.find(form => form.area_form_is_required && !form.filled);

        if (mandatoryFormExist) {
          this.toaster.errorShow('Please click the “+” button next to the form, complete all required fields, and submit the form to continue.', 'Complete Required Form', { closeButton: true, timeOut: 3000 });
          wizardObj.stop();
          return;
        }

        if (this.commentFormGroup.invalid) {
          setTimeout(() => {
            this.commentFormGroup.markAllAsTouched();
          });
          wizardObj.stop();
          return;
        }

        else {
          this.isLastStepReached = true;
        }
        this.cdr.detectChanges();
      });
      wizard.on('beforePrev', (wizardObj) => {
        this.isLastStepReached = false;
        this.cdr.detectChanges();
      });

    });
  }

  ngAfterViewInit() {

  }


  taskFormSelectChangeHandler() {
    const unselectedExist = this.tasks.find(task => !task.filled) || this.forms.find(form => !form.filled);
    if (unselectedExist) {
      setTimeout(() => {
        this.commentFormGroup.get('comment').setValidators([Validators.required]);
        this.commentFormGroup.get('comment').updateValueAndValidity();
        // this.commentFormGroup.markAllAsTouched();
      }, 10);

    } else {
      setTimeout(() => {
        this.commentFormGroup.get('comment').clearValidators();
        this.commentFormGroup.get('comment').updateValueAndValidity();
      }, 10);
    }
  }
  setFormsTaskGroup(data) {
    this.loading.set(false);
    if (data.success) {
      if (data.data.data.areas && data.data.data.areas.area_forms) {
        this.forms = data.data.data.areas.area_forms;
      }

      if (data.data.data.areas && data.data.data.areas.area_task_groups) {
        this.tasks = data.data.data.areas.area_task_groups;
      }
      if (!this.forms.length && !this.tasks.length) {
        this.isLastStepReached = true;
      }
    }
    this.setWizardConfig();

  }

  formClickHandler(form) {
    this.activeForm = form;
    const existingForm = this.timesheetForms.find(formInfo => formInfo.timesheet_form_fk_form_id === form.form.form_id);
    if (existingForm) {
      this.openFormModal(existingForm.timesheet_form_details);

      return;
    }
    this.dispatchGetFormById(form.form.form_id);
  }

  taskGroupClickHandler(task) {
    this.activeTasks = task;
    const existingTask = this.timesheetTasksForEditMode.find(taskInfo => taskInfo.task.task_group_id === task.task_group.task_group_id);
    if (existingTask) {
      this.openTaskGroupModal([existingTask], true);

      return;
    }
    this.dispatchTaskGroupById(task.task_group.task_group_id);
  }

  dispatchGetTaskGroupForm() {
    this.loading.set(true);
    this.clientStoreService.dispatchClientCommon({
      callback: this.setFormsTaskGroup.bind(this), data: { area_id: this.areaId },
      module: CLIENT_METHOD_CONSTANT.FORMS_TASK_GROUP_BY_AREA,
      method: API_METHOD_CONSTANTS.INSERT,
    });
  }

  openFormModal(form) {
    const componetRef = this.openPopUp(FormActionComponent, { fromInput: true, formData: form }, { centered: true, size: 'lg', backdrop: 'static' });
    componetRef.result.then(res => {
      if (res.formFilled) {
        this.activeForm.filled = true;
        this.timesheetForms = this.timesheetForms.filter(formInfo => formInfo.timesheet_form_fk_form_id !== form.form_id);
        const formPayload = {
          timesheet_form_fk_form_id: form.form_id,
          timesheet_form_fk_form_name: form.form_name,
          timesheet_form_details: form,
          timesheet_form_config: {},
        };
        this.timesheetForms.push(formPayload);
        this.taskFormSelectChangeHandler();
        this.cdr.detectChanges();
      }
    });
  }

  openTaskGroupModal(tasks, editMode = false) {

    const componetRef = this.openPopUp(TaskGroupListActionComponent, { task: tasks.length ? tasks[0] : [], saveData: false, editMode }, { centered: true, size: 'lg', backdrop: 'static' });
    componetRef.result.then(res => {
      if (res && res.tasks) {
        if (res.allTaskDone) {
          this.activeTasks.filled = true;
        } else {
          this.activeTasks.filled = false;
        }
        let taskGroupId = 0;
        if (tasks && tasks.length) {
          // for first time there is on task object no new task object
          taskGroupId = (tasks[0].task_group_id || (tasks[0] && tasks[0].task ? tasks[0].task.task_group_id : 0));
        }
        this.timeSheetTasks = this.timeSheetTasks.filter(task => task.timesheet_task_group_fk_task_group_id !== taskGroupId);
        this.timesheetTasksForEditMode = this.timesheetTasksForEditMode.filter(task => task.task.task_group_id !== taskGroupId);
        this.timeSheetTasks.push(res.tasks);
        this.timesheetTasksForEditMode.push(res.taskForEditMode);
        this.taskFormSelectChangeHandler();
        this.cdr.detectChanges();
      }
    });
  }


  setFormData(data) {
    if (data.success && data.data.data.forms) {
      const form = data.data.data.forms;
      this.openFormModal(form);
    }
  }
  setTaskGroupData(data) {
    if (data.success) {
      const tasks = data.data.task_groups || [];
      tasks.forEach(task => task.task_group_child = task.taskGroupChildren);
      this.openTaskGroupModal(tasks);
    }
  }

  successHandler(data) {
    this.loading.set(false);
    if (data.success) {
      if (data.data && data.data.isError && data.data.status === 202) {
        this.toaster.errorShow(data.data.message, '', { closeButton: true, timeOut: 3000 });
        return;
      }

      this.activeModal.close({ reload: true });
    }
  }

  saveClickHandler() {
    if (this.loading()) {
      return;
    }
    const comment = this.commentFormGroup.value.comment;
    const payload = {
      client_id: this.shiftInfo.client.client_id,
      location_id: this.shiftInfo.location.location_id,
      scan_area_id: this.areaId,
      area_id: this.shiftInfo.area.area_id,
      // loop_sequence_number: this.loopInfo ? this.loopInfo.loop_sequence_number : undefined,
      // loop_sequence_id: this.loopInfo ? this.loopInfo.loop_sequence_id : undefined,
      timezone_id: 1,
      is_unscheduled: this.shiftInfo.shift ? false : true,
      timesheet_id: this.shiftInfo.timesheet.timesheet_id,
      timesheet_log: {
        timesheet_log_name: '',
        timesheet_log_config: {},
        timesheet_log_is_paid: true,
      },
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: '',
        timesheet_transaction_scan_type: 'Manual',
        timesheet_transaction_scan_image_url: '',
        timesheet_transaction_notes: comment,
        timesheet_transaction_latitude: this.location.latitude.toString(),
        timesheet_transaction_longitude: this.location.longitude.toString(),
        timesheet_transaction_accuracy: 0,
      },
      timesheet_forms: this.timesheetForms,
      timesheet_task_groups: this.timeSheetTasks,
    };
    if (this.user_id) {
      payload['user_id'] = this.user_id;
    }
    this.dispatchSaveTaskGroupForms(payload);
  }

  dispatchGetFormById(id) {
    this.formStoreService.dispatchFormCommon({
      module: FORM_METHOD_CONSTANT.FORM,
      method: API_METHOD_CONSTANTS.GET_BY_ID,
      data: { id },
      callback: this.setFormData.bind(this),
    });
  }

  dispatchTaskGroupById(id) {
    this.taskStoreService.dispatchTaskCommon({
      module: TASK_METHOD_CONSTANT.TASK_GROUP,
      method: API_METHOD_CONSTANTS.GET_BY_ID,
      data: { task_group_id: id },
      callback: this.setTaskGroupData.bind(this),
    });
  }

  // dispatchSaveTaskGroupForms(data) {
  //   this.loading = true;
  //   this.timesheetStoreService.dispatchTimesheetCommon({
  //     module: this.isLoopScan ? TIMESHEET_METHOD_CONSTANT.TIMESHEET_SCAN_LOOP : TIMESHEET_METHOD_CONSTANT.TIMESHEET_SCAN,
  //     method: API_METHOD_CONSTANTS.INSERT,
  //     data,
  //     callback: this.successHandler.bind(this),
  //   });
  // }
  dispatchSaveTaskGroupForms(data) {
    this.loading.set(true);
    this.timesheetStoreService.dispatchTimesheetCommon({
      module: this.isPatrolScan ? TIMESHEET_METHOD_CONSTANT.TIMESHEET_SCAN_PATROL : TIMESHEET_METHOD_CONSTANT.TIMESHEET_SCAN,
      method: API_METHOD_CONSTANTS.INSERT,
      data,
      callback: this.successHandler.bind(this),
    });
  }

}
